import React from 'react'
import { useHistory } from 'react-router'
import {
  GoalUpdateSortOptions,
  SingleGoalUpdate,
  useGoalUpdatesQuery,
} from 'Generated/graphql-types'
import { GOALS_PATH } from 'Components/Pages/Impact/GoalsDashboard/types'
import { Tooltip } from '@resiliatech/birdsong'
import { ChatBubbleOutline } from '@material-ui/icons'
import { useAppState } from 'Context/AppContext/AppContext'
import { WithWidgetLoading } from '../WithWidgetLoading'
import {
  UpdatesContainer,
  UpdateItem,
  UpdateAuthor,
  UpdateDescription,
  ViewGoalButton,
  ArrowForward,
} from './GoalProgressUpdates.styled'
import { Header } from '../ImpactReportDashboard.styled'
import { EmptyState } from '../EmptyState/EmptyState'
import { dispatchProgressUpdateGoalClicked } from '../analytics.utils'

export const GoalProgressUpdates = () => {
  const history = useHistory()
  const { userConfig, nonprofitOrgConfig } = useAppState()
  const { platformPlan, orgId: nonprofitOrgId } = nonprofitOrgConfig
  const { data, loading: goalUpdatesLoading } = useGoalUpdatesQuery({
    variables: {
      nonprofitOrgId,
      sort: GoalUpdateSortOptions.UpdatedAtDesc,
    },
  })
  const { id: userId } = userConfig
  const goalUpdates = data?.goalUpdates?.nodes as SingleGoalUpdate[]
  const isEmptyState = !goalUpdatesLoading && !goalUpdates?.length

  const handleViewGoalClicked = (goalId: number) => {
    history.push(`${GOALS_PATH}/${goalId}?section=comments`)
  }

  return (
    <WithWidgetLoading
      loading={goalUpdatesLoading}
      width='49.22%'
      height={isEmptyState ? 'auto' : '500px'}
    >
      <UpdatesContainer>
        <Header> Goal Progress Updates</Header>
        {isEmptyState ? (
          <EmptyState
            icon={ChatBubbleOutline}
            title='No Updates'
            description='The most recent updates across all of your Goals will appear here.'
          />
        ) : (
          <div>
            {goalUpdates?.map((update) => (
              <UpdateItem key={update.id}>
                <Tooltip
                  title={`Goal: ${update.goalTitle}`}
                  key={update.id}
                  arrow
                  placement='left'
                >
                  <div>
                    <UpdateAuthor>
                      {`${update.lastUpdatedUserFirstname} ${update.lastUpdatedUserLastname}`}
                    </UpdateAuthor>
                    <UpdateDescription>{update.description}</UpdateDescription>
                    <ViewGoalButton
                      variant='text'
                      onClick={() => {
                        handleViewGoalClicked(update.goalId)
                        dispatchProgressUpdateGoalClicked({
                          goalTitle: update.goalTitle,
                          goalId: update.goalId,
                          userId,
                          platformPlan: platformPlan || '',
                          progressUpdateValue: update.description,
                        })
                      }}
                    >
                      View Goal <ArrowForward />
                    </ViewGoalButton>
                  </div>
                </Tooltip>
              </UpdateItem>
            ))}
          </div>
        )}
      </UpdatesContainer>
    </WithWidgetLoading>
  )
}
